export default "__VITE_ASSET__oqYEc6MU__"